// Pure helpers + constants extracted from AdminUsersPage to keep the page file
// under the 300-line hard limit. No React, no data fetching — just shaping +
// label maps for rendering.

export const PROVIDER_LABELS = { google: '구글', naver: '네이버', kakao: '카카오', cognito: '이메일', social: '소셜' };
export const PROVIDER_COLORS = { google: '#4285f4', naver: '#03c75a', kakao: '#fee500', cognito: '#888', social: '#aaa' };

export const SORT_OPTIONS = [
  { key: 'latestCreatedAt', label: '최신 가입순' },
  { key: 'memberCount',     label: '계정 통합 많은순' },
  { key: 'hasAdmin',        label: '관리자 우선' },
];

// Same phoneNumber → grouped together. Users without phone → standalone groups.
export function groupByPhone(users) {
  const groups = {};
  const orphans = [];
  for (const u of users) {
    if (u.phoneNumber) {
      if (!groups[u.phoneNumber]) groups[u.phoneNumber] = [];
      groups[u.phoneNumber].push(u);
    } else {
      orphans.push(u);
    }
  }
  const grouped = Object.entries(groups).map(([phone, members]) => ({ phone, members }));
  const single = orphans.map(u => ({ phone: null, members: [u] }));
  return [...grouped, ...single];
}

// Group-level sort value. Missing values sink. Default direction is desc.
function groupSortValue(group, key) {
  if (key === 'memberCount') return group.members.length;
  if (key === 'hasAdmin') return group.members.some(m => m.isAdmin) ? 1 : 0;
  if (key === 'latestCreatedAt') {
    const stamps = group.members.map(m => m.createdAt).filter(Boolean);
    if (stamps.length === 0) return null;
    return stamps.reduce((a, b) => (a > b ? a : b));
  }
  return null;
}

export function compareGroups(a, b, key) {
  const av = groupSortValue(a, key);
  const bv = groupSortValue(b, key);
  if (av == null && bv == null) return 0;
  if (av == null) return 1;
  if (bv == null) return -1;
  if (typeof av === 'number' && typeof bv === 'number') return av - bv;
  return String(av).localeCompare(String(bv), 'ko-KR');
}
